// In src/components/GroupInviteModal.js

import React, { useState, useEffect } from 'react';
import {
  Modal, Box, Typography, Button, List, ListItem, ListItemText,
  Checkbox, ListItemIcon, Avatar, ListItemAvatar, ListItemButton
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight: '80vh',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
};

function GroupInviteModal({ open, onClose, onInvite, allChurchMembers, currentGroupMembers }) {
  const [selectedUids, setSelectedUids] = useState([]);

  const currentMemberUidSet = new Set(currentGroupMembers);
  
  // Corrected: Sort the list of available members
  const availableMembers = allChurchMembers
    .filter(member => !currentMemberUidSet.has(member.authUid))
    .sort((a, b) => {
        const lastNameComparison = a.lastName.localeCompare(b.lastName);
        if (lastNameComparison !== 0) return lastNameComparison;
        return a.firstName.localeCompare(b.firstName);
    });

  useEffect(() => {
    if (open) {
      setSelectedUids([]);
    }
  }, [open]);

  const handleToggle = (uid) => () => {
    const currentIndex = selectedUids.indexOf(uid);
    const newSelectedUids = [...selectedUids];

    if (currentIndex === -1) {
      newSelectedUids.push(uid);
    } else {
      newSelectedUids.splice(currentIndex, 1);
    }

    setSelectedUids(newSelectedUids);
  };

  const handleSendInvites = () => {
    onInvite(selectedUids);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="group-invite-modal-title"
    >
      <Box sx={style}>
        <Typography id="group-invite-modal-title" variant="h6" component="h2">
          Invite Members
        </Typography>
        <Box sx={{ flexGrow: 1, overflowY: 'auto', my: 2 }}>
          <List dense>
            {availableMembers.map((member) => (
              <ListItem key={member.authUid} disablePadding>
                <ListItemButton onClick={handleToggle(member.authUid)}>
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={selectedUids.indexOf(member.authUid) !== -1}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemAvatar>
                      <Avatar>{member.firstName.charAt(0)}</Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={`${member.firstName} ${member.lastName}`} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSendInvites} disabled={selectedUids.length === 0}>
            Send Invites
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default GroupInviteModal;